import pluralize from 'pluralize';

export const getAverageResponseTimeLabel = (timeInMs: number): string | undefined => {
  const timeInMsInDay = 24 * 60 * 60 * 1000;
  const timeInMsInHour = 60 * 60 * 1000;
  let day = Math.floor(timeInMs / timeInMsInDay);
  let hour = Math.floor((timeInMs - day * timeInMsInDay) / timeInMsInHour);
  let minute = Math.round((timeInMs - day * timeInMsInDay - hour * timeInMsInHour) / 60000);

  if (minute === 60) {
    hour++;
    minute = 0;
  }

  if (hour === 24) {
    day++;
    hour = 0;
  }

  if (day >= 3 && day <= 7) {
    return 'a few days';
  } else if ([1, 2].includes(day)) {
    return 'a day';
  } else if (hour > 0 && hour < 24) {
    return pluralize('hour', hour, true);
  }

  return undefined;
};
